export const Images = {
    logo: require('../assets/images/logo.png'),
    upload: require('../assets/images/upload.png'),
    add: require('../assets/images/add.png')
}